import React from 'react';
import get from 'lodash/get';
import { ScoreCell, ScoreTotalCell, ScoreTodayCell } from 'components/scores';
import { playerSitecoreData } from 'components/live-player';
import LeaderboardWidgetFavoriteNameContent from './leaderboard-widget-favorite-name-content';
import LeaderboardCellToPar from '../../leaderboard/js/components/leaderboard-cell-to-par';
import LeaderboardTeeTimesGroup from '../../leaderboard/js/components/leaderboard-tee-times-group';
import { stateTypes } from './enums';

const LeaderboardWidgetFavoriteCell = ({
    state, player, scoringLeaderboard, isPlayOff, liveScanner, stateFavoriteButton
}) => {
    const playerSD = player.sitecoreData || playerSitecoreData;
    const renderCell = () => {
        switch (state) {
            case stateTypes.POSITION:
                return get(player, 'position.displayValue') || '-';
            case stateTypes.NAME:
                return <LeaderboardWidgetFavoriteNameContent player={player} isPlayOff={isPlayOff} liveScanner={liveScanner} stateFavoriteButton={stateFavoriteButton}/>;
            case stateTypes.TEE:
                return (scoringLeaderboard.currentRound === get(scoringLeaderboard, 'currentRound')) &&
                        <LeaderboardTeeTimesGroup player={player} scoringLeaderboard={scoringLeaderboard} isPlayOff={isPlayOff}
                        />;
            case stateTypes.TO_PAR:
                return (isPlayOff ? <LeaderboardCellToPar player={player} playerSD={playerSD} view={player.view} isPlayOff={isPlayOff}/> : <ScoreTotalCell par={player.toPar} />);
            case stateTypes.HOLE:
                return <ScoreCell>{player.hole || '-'}</ScoreCell>;
            case stateTypes.TODAY:
                return <ScoreTodayCell par={player.today} />;
            default:
                return null;
        }
    };

    return (
        <div className={`leaderboard-widget-favorite__cell is-${state}`}>
            {renderCell()}
        </div>
    );
};

export default LeaderboardWidgetFavoriteCell;
